const routeComponent = `app/containers/ActionPlansImportSummary`

export const DEFAULT_ACTION = `${routeComponent}/DEFAULT_ACTION`

export const GET_SUMMARY_WATCHER = `${routeComponent}/GET_SUMMARY_WATCHER`
export const GET_SUMMARY_SUCCESS = `${routeComponent}/GET_SUMMARY_SUCCESS`
export const GET_SUMMARY_FAILED = `${routeComponent}/GET_SUMMARY_FAILED`

export const UPLOAD_TEMPLATE_WATCHER = `${routeComponent}/UPLOAD_TEMPLATE_WATCHER`
export const UPLOAD_TEMPLATE_SUCCESS = `${routeComponent}/UPLOAD_TEMPLATE_SUCCESS`
export const UPLOAD_TEMPLATE_FAILED = `${routeComponent}/UPLOAD_TEMPLATE_FAILED`

export const SAVE_EXCEL_WATCHER = `${routeComponent}/SAVE_EXCEL_WATCHER`
export const SAVE_EXCEL_SUCCESS = `${routeComponent}/SAVE_EXCEL_SUCCESS`
export const SAVE_EXCEL_FAILED = `${routeComponent}/SAVE_EXCEL_FAILED`
export const SAVE_EXCEL_PROGRESS = `${routeComponent}/SAVE_EXCEL_PROGRESS`
